<template>
  <FinderCard
    data-test="finder-usage-card"
    :title="criterion.title"
    :tooltip="criterion.tooltip"
  >
    <ul class="flex flex-col gap-8">
      <li v-for="option in options" :key="option.id" class="flex-1 flex">
        <RevButtonBase
          :aria-pressed="isSelected(option.id)"
          class="flex flex-1 h-full items-center rounded-lg border-1 border-transparent px-16 py-14 motion-safe:transition motion-safe:duration-[225ms] outline-2 outline-offset-4 focus-visible:outline-default-hi"
          :class="
            isSelected(option.id)
              ? 'bg-action-default-mid-pressed text-onaction-default-mid-pressed hover:bg-action-default-mid-hoverpressed'
              : 'bg-action-default-mid text-onaction-default-mid hover:bg-action-default-mid-hover'
          "
          :data-state="isSelected(option.id) ? 'selected' : 'unselected'"
          data-test="finder-usage-pill"
          @click="toggleId(option.id)"
        >
          <span class="heading-3">{{ option.label }}</span>
        </RevButtonBase>
      </li>
    </ul>
  </FinderCard>
</template>

<script lang="ts" setup>
import { RevButtonBase } from '@ds/components/ButtonBase'

import type {
  FinderOption,
  FinderUsagesCriterion,
} from '../../../../composables/useFinder/useFinder.types'
import FinderCard from '../FinderCard/FinderCard.vue'

defineProps<{
  criterion: FinderUsagesCriterion
  options: FinderOption[]
}>()

const selectedIds = defineModel<string[]>('selectedIds', { default: () => [] })

function isSelected(id: string): boolean {
  return selectedIds.value.includes(id)
}

function toggleId(id: string): void {
  const current = selectedIds.value

  selectedIds.value = current.includes(id)
    ? current.filter((v) => v !== id)
    : [...current, id]
}
</script>
